import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Pagination from "@/components/pagination";
import { PaginationType } from "@/utils/interface.global";
import { GrFormNext } from "react-icons/gr";
import { GrFormPreviousLink } from "react-icons/gr";

interface Props {
  currentPage: number;
  nameState: string;
  setPropsID: React.Dispatch<React.SetStateAction<string | null>>;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  pagination: PaginationType | null;
  dataRendering?: any;
  isVoucherActivatedNumber?: boolean | undefined;
  contentHeader: string;
  isAction?: boolean | undefined;
  isBack?: boolean | undefined;
  handleBackButton?: () => void | undefined;
}

const TableRendering: React.FC<Props> = ({
  setPropsID,
  currentPage,
  nameState,
  setCurrentPage,
  pagination,
  isVoucherActivatedNumber,
  contentHeader,
  isAction,
  dataRendering,
  isBack,
  handleBackButton,
}: Props) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const props = { currentPage, setCurrentPage, pagination };

  const handleEnableEventList = (ID: string) => {
    setPropsID(ID);
    const activatedTabs = searchParams.get("activatedTabs");
    if (activatedTabs) {
      const options = {
        search: location.search + `&${nameState}=${ID}`,
      };
      navigate(options, { replace: true });
    }
  };

  return (
    <>
      <div className="list-table">
        {isBack && (
          <div className="cursor-pointer font-bold flex items-center gap-1 hover:cursor-pointer hover:underline pb-4">
            <GrFormPreviousLink />
            <span className="text-sm" onClick={handleBackButton}>
              Quay Lại
            </span>
          </div>
        )}
        <div className="flex justify-between items-center">
          <h1 className="text-sm font-bold text-red-500">{contentHeader}</h1>
          {isVoucherActivatedNumber && (
            <div className="inline-flex items-center gap-1 text-red-500 font-bold">
              <p className="text-sm">Số Phiếu Thay Dầu {pagination?.total}</p>
            </div>
          )}
        </div>
        <div className="flex flex-col pt-4 overflow-x-auto">
          <table className="min-w-full text-left text-sm font-light">
            <thead className="border-b font-medium dark:border-neutral-500">
              <tr>
                <th scope="col" className="px-4 py-2">
                  #
                </th>
                {isAction ? (
                  <th scope="col" className="px-4 py-2 text-left">
                    {isAction ? "Tên Sự Kiện" : "Họ Và Tên"}
                  </th>
                ) : (
                  <></>
                )}
                <th scope="col" className="px-4 py-2 text-center">
                  {isAction ? " Phiếu Thay Dầu Kích Hoạt" : "Mã Phiếu Thay Dầu"}
                </th>
                <th scope="col" className="px-4 py-2 text-center">
                  {isAction ? "Thời Gian Sự Kiện" : "Thời Gian Kết Thúc"}
                </th>
                {isAction ? (
                  <th scope="col" className="px-4 py-2 text-right">
                    Trạng Thái
                  </th>
                ) : (
                  <></>
                )}
              </tr>
            </thead>
            <tbody>
              {dataRendering &&
                dataRendering.map((res: any, index: any) => (
                  <tr
                    key={index}
                    className="border-b transition duration-300 ease-in-out hover:bg-white hover:text-red-500 hover:font-bold cursor-pointer"
                    onClick={() => handleEnableEventList(String(res.id))}
                  >
                    <td className="whitespace-nowrap px-4 py-2 font-medium">
                      {res.id}
                    </td>
                    {isAction ? (
                      <td className="whitespace-nowrap px-4 py-2 font-medium">
                        {res.name_event || res.kh_name}
                      </td>
                    ) : (
                      <></>
                    )}
                    <td className="whitespace-nowrap px-4 py-2 font-medium text-center">
                      {Number(res.voucher_active) || res.code_voucher}
                    </td>
                    <td className="whitespace-nowrap px-4 py-2 font-medium text-center">
                      {res.time_active || res.date_start + "-" + res.date_end}
                    </td>
                    {isAction ? (
                      <td className="whitespace-nowrap px-4 py-2 font-medium text-right">
                        {res.status}
                      </td>
                    ) : (
                      <></>
                    )}
                    <td className="whitespace-nowrap py-2">
                      <GrFormNext />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="list-pagination">
        <Pagination {...props} />
      </div>
    </>
  );
};

export default TableRendering;
